// All needed imports
import { ButtonComponent } from './button/button.component';
import { InputComponent } from './input/input.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectComponent } from './select/select.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { BtnTooltipComponent } from './btn-tooltip/btn-tooltip.component';
import { RadioComponent } from './radio/radio.component';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { InputMaskModule } from 'primeng/inputmask';

import { DropdownModule } from 'primeng/dropdown';
import { CalendarComponent } from './calendar/calendar.component';
import { RadioCardComponent } from './radio-card/radio-card.component';
import { SummaryComponent } from './summary/summary.component';
import { RadioPointComponent } from './radio-point/radio-point.component';
import { UtilsService } from '../../services/utils/utils.service';
import { ChipsModule } from 'primeng/chips';
import { ChipsComponent } from './chips/chips.component';
import { SelectMultipleComponent } from './select-multiple/select-multiple.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableComponent } from './table/table.component';
import { TableSimpleComponent } from './table-simple/table-simple.component';
import { DomiciliationComponent } from './domiciliation/domiciliation.component';
import { MultiselectModalComponent } from './multiselect-modal/multiselect-modal.component';
import { UploadDocComponent } from './upload-doc/upload-doc.component';
import { FileUploadModule } from 'primeng/fileupload';
import { InputBtnComponent } from './input-btn/input-btn.component';
import { SummaryLegalComponent } from './summary-legal/summary-legal.component';
import { LoadingComponent } from './loading/loading.component';

@NgModule( {
  /**
   * Declarate the needed components
   */
  declarations: [
    ButtonComponent,
    InputComponent,
    SelectComponent,
    CheckboxComponent,
    BtnTooltipComponent,
    RadioComponent,
    CalendarComponent,
    RadioCardComponent,
    SummaryComponent,
    RadioPointComponent,
    ChipsComponent,
    SelectMultipleComponent,
    TableComponent,
    TableSimpleComponent,
    DomiciliationComponent,
    MultiselectModalComponent,
    UploadDocComponent,
    InputBtnComponent,
    SummaryLegalComponent,
    LoadingComponent
  ],
  /**
   * Import modules which will be used in this module
   */
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    InputTextModule,
    CalendarModule,
    DropdownModule,
    TooltipModule,
    TranslateModule,
    ChipsModule,
    MultiSelectModule,
    FileUploadModule,
    InputMaskModule
  ],
  /**
   * Indicate the modules which will be used in other modules
   */
  exports: [
    ButtonComponent,
    InputComponent,
    SelectComponent,
    CheckboxComponent,
    RadioCardComponent,
    BtnTooltipComponent,
    RadioComponent,
    CalendarComponent,
    SummaryComponent,
    RadioPointComponent,
    ChipsComponent,
    SelectMultipleComponent,
    TableComponent,
    TableSimpleComponent,
    DomiciliationComponent,
    MultiselectModalComponent,
    UploadDocComponent,
    InputBtnComponent,
    SummaryLegalComponent,
    LoadingComponent,

    FormsModule,
    DropdownModule,
    InputTextModule,
    CalendarModule,
    TranslateModule,
    ChipsModule,
    MultiSelectModule,
    FileUploadModule,
    InputMaskModule
  ],
  /**
   * Declarate the services used
   */
  providers: [ UtilsService ]
} )

/**
 * Presenters Module Class
 */
export class PresentersModule { }
